import React, { useState, useEffect } from 'react'
import { Form } from 'reactstrap'
import Table from '../../../components/Table'
import SuccessPopups from '../../../components/Popups/SuccessPopups';
import axios from 'axios';
import { environment } from '../../../env';
import { Link } from 'react-router-dom';
import WarningPopup from '../../../components/Popups/WarningPopup';
import { useDispatch, useSelector } from 'react-redux';
import { loaderAction, warningModalToggle } from '../../../redux/actions/Index';
import EmptyTable from '../../../components/errorComponents/EmptyTable';
import { useForm } from 'react-hook-form';
import _ from "lodash";
import 'react-toastify/dist/ReactToastify.css';
import { Eye, Trash } from '@phosphor-icons/react';
import moment from 'moment';
import EditQuery from '../../../components/Modal/EditQuery';
import PathName from '../../../components/PathName/PathName';
import { ArrowSquareLeft, ArrowSquareRight } from 'iconsax-react';

const Querys = () => {
    const [filterQuery, setFilterQuery] = useState()
    const dispatch = useDispatch();
    const queryList = useSelector((state) => state?.ModalReducer?.query);
    const user = useSelector((state) => state?.Reducers?.userdata);
    const userProject = useSelector((state) => state?.ModalReducer?.userproject);
    const [usersList, setUsersList] = useState([])
    const [pageNo, setPageNo] = useState(1);
    const [emptyerr, setEmptyerr] = useState(false);
    const [records, setRecords] = useState(10);
    const [loading, setLoading] = useState(false);
    const [nextIsValid, setNextIsValid] = useState(false);
    const [prevIsValid, setPrevIsValid] = useState(false);
    const {
        register,
        handleSubmit,
        watch,
        formState: { errors },
    } = useForm();


    useEffect(() => {
    }, [queryList])

    const deleteQueryData = (id) => {
        dispatch(warningModalToggle(id));
    };

    const deleteData = (id) => {
        dispatch(loaderAction(true))
        dispatch(warningModalToggle(id))
        axios.delete(`${environment.baseUrl}edit-query/${id}`).then(res => {
            if (res.data.code === 200) {
                SGFilterCallPageChange(1, undefined);
                dispatch(loaderAction(false))

            }
        })
            .catch(res => {
                dispatch(loaderAction(false))
                console.log("error");
            })
    };

    const getAllUser = async () => {
        try {
            axios.get(`${environment.baseUrl}registration/`).then(res => { setUsersList(res.data) });
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        SGFilterCallPageChange(1, undefined)
        getAllUser();
    }, [])


    const columns = [
        {
            name: 'Date',
            selector: row => moment(row.created_at).format('DD/MM/YYYY'),
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Name',
            selector: row => row?.gala_investor?.Investors?.name,
            wrap: true,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Gala',
            selector: row => row?.gala_investor?.gala?.gala_no,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Sub Gala',
            selector: row => row.gala_investor?.sub_gala_name,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Query',
            selector: row => row.comment.length > 15 ? row.comment.slice(0, 15) + '...' : row.comment,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Assigned To',
            selector: row => row.assign == '' ? 'Not Assigned' : row.assign,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Status',
            selector: (row) =>
                <label className={`${row.status === 'Complete' && 'icon-bg-green icon-color-green '} ${row.status === 'Pending' && 'icon-bg-red icon-color-red'}   rounded-pill status-box rounded fs-4`}>{row.status}</label>,
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Action',
            cell: (row) => <div className="d-flex justify-content-between align-items-center gap-2 ">
                <Link to={`/Query/${row.id}`} className="icon-bg-green border-0 px-2 py-3 rounded"><Eye size="28" className='icon-color-green' /></Link>
                {user?.role != 'user' && <>
                    <EditQuery query={row} usersListProp={usersList} />
                    {user?.role == 'superadmin' && <button onClick={() => deleteQueryData(row.id)} id={row.ID} className="icon-bg-red border-0 px-2 py-3 rounded"><Trash size="24" className='icon-color-red' /></button>}
                </>}
            </div>,
        },
    ];

    const SGFilterCallPageChange = async (localPage, localRecord) => {
        var searchstatus = watch('status');
        let SearchUrl = "";
        if (localPage == undefined) {
            SearchUrl = `${environment.baseUrl}/query-filter/?investor=&building=&gala=&subgala=&assign=&project=${userProject}&status=${searchstatus ? searchstatus : ""}&p=1&records=${localRecord}`;
        } else if (localRecord == undefined) {
            SearchUrl = `${environment.baseUrl}/query-filter/?investor=&building=&gala=&subgala=&assign=&project=${userProject}&status=${searchstatus ? searchstatus : ""}&p=${localPage}&records=${records}`;
        }
        setLoading(true);
        const result = await axios(SearchUrl).then((res) => {
            if (res?.data?.next != null && nextIsValid != true) {
                setNextIsValid(true)
            } else if (res?.data?.next == null && nextIsValid != false) {
                setNextIsValid(false)
            }
            if (res?.data?.previous != null && prevIsValid != true) {
                setPrevIsValid(true)
            } else if (res?.data?.previous == null && prevIsValid != false) {
                setPrevIsValid(false)
            }
            console.log(res?.data?.results);
            if (res?.data?.results.length > 0) {
                const dat = res?.data?.results
                if (dat.length != 0) {
                    setFilterQuery(dat)
                    setEmptyerr(false)
                } else {
                    setEmptyerr(true);
                    dispatch(loaderAction(false))
                }
            } else {
                setEmptyerr(true);
            }
            setLoading(false);
        })
    }

    const pageChangeHandler = (LocalPageNo) => {
        if (((pageNo < LocalPageNo) && nextIsValid) || ((pageNo > LocalPageNo) && prevIsValid)) {
            SGFilterCallPageChange(LocalPageNo, undefined) // page change call
            setPageNo(LocalPageNo)
        }
    }

    const recordChangeHandler = (recordSize) => {
        SGFilterCallPageChange(undefined, recordSize) // record change call
        setRecords(recordSize);
        setPageNo(1);
    }


    return (
        <>
            <PathName />
            <SuccessPopups />
            <WarningPopup deleteData={deleteData} />
            <div className="Projects-main">
                <Form >
                    <div className='my-4 row'>
                        <div className='col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1'>
                            <div className='mt-1  d-flex gap-3'>
                                <select id="status" name="status" className="p-4  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                    {...register("status", { onChange: (e) => { SGFilterCallPageChange(1, undefined) } })}>
                                    <option value='' >Select Status</option>
                                    <option value="Pending">Pending</option>
                                    <option value="Complete">Complete</option>
                                </select>
                            </div>
                            <br />
                        </div>
                    </div>
                </Form>
                <br />
                <div className="bg-white rounded-5 mb-5 shadow-sm  p-4 p-md-4 p-lg-5 p-xl-5">
                    <div >
                        <div className="d-flex justify-content-between align-items-center">
                            <h1 className='mb-5 title-font-bold '>QUERY REPORTS</h1>
                        </div>
                        {emptyerr ? <EmptyTable /> : <Table pageinationProp={true} columns={columns} data={filterQuery} />}
                        <div className="d-flex align-items-center justify-content-between gap-md-5 gap-lg-5 gap-xl-5  flex-column flex-md-row flex-lg-row flex-xl-row">
                            <div className="pb-3 pt-1 pb-md-5 pb-lg-5 pb-xl-5">
                                {""}
                            </div>
                            <div className='d-flex mr-2 gap-3 align-items-center justify-content-between'>
                                <select
                                    className="mt-4 p-3 select-width-data-table-wo-pagination title-font-500 fs-2"
                                    defaultValue={"10"}
                                    {...register("recordSize", { onChange: (e) => { recordChangeHandler(e.target.value) } })}
                                >
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>

                                </select>
                                <span onClick={() => { pageChangeHandler(pageNo - 1) }} className="fs-3 d-flex gap-3 title-font-600 ps-2 pe-1 mt-4"><ArrowSquareLeft color='#6271de' size="28" variant="Bold" /></span>
                                <span onClick={() => { pageChangeHandler(pageNo + 1) }} className="fs-3 d-flex gap-3 title-font-600 ps-2 pe-2 mt-4"><ArrowSquareRight color='#6271de' size="28" variant="Bold" /></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Querys
